import React from 'react'
import { useTranslation } from 'react-i18next';
import useDesktopSize from '../../../../../../utils/hooks/useDesktopSize';
import { Ticket } from '../../../../../models/Ticket';
import QrCodeModal from '../../../../../../features/QRcode';

interface IProps {
  pass: Ticket;
}

const DetailsQR: React.FC<IProps> = ({ pass }) => {
    const isDesktop = useDesktopSize();
    const { t } = useTranslation();
    
    const getQrSectionText = () => {
        return isDesktop ? t("dostep_do_biletu_desktop") : t("pokaz_ten_kod_mobile");
      };

  return (
    <div className="ticket-details__qr-section">
    <h5>{t("zeskanuj_ten_qr")}</h5>
    <span className="body-text-small text-color-light-gray">{getQrSectionText()}</span>
    <div className="ticket-details__qr-container">
      <QrCodeModal name={pass.name} trhId={pass.trhId || ""} customDesktopSize={200} customMobileSize={180} />
    </div>
  </div>
  )
}

export default DetailsQR